import router from "./index";

export default [{
  path: "/VenueBooking",
  component: () => import('../views/VenueBooking/VenueBooking'),
  beforeEnter: (to, from, next) => {
    if (router.app.$cookies.get("user") === "student")
      next();
    else
      router.replace("/home");
  },
  meta: {
    title: '场馆预约'
  },
  children: [
    {
      path: '/',
      redirect: 'VenueSList'
    },
    {
      path: 'VenueSList',
      component: () => import('../views/VenueBooking/VenueSList/VenueSList'),
      meta: {
        title: '场馆列表'
      },
    },
    {
      path: 'vsqc',
      component: () => import('../views/VenueBooking/VenueScanQrCode/VenueScanQrCode'),
      meta: {
        title: '场馆扫码'
      },
    }, {
      path: 'VSuccess',
      component: () => import('../views/VenueBooking/VenueBookingSuccess/VenueBookingSuccess'),
      meta: {
        title: '预约成功'
      },
    },
  ]
},]
